import Section from './PopularColorsSection'
import isEmpty from './PopularColorsIsEmpty'

export default { Section, isEmpty }
